import type { Dispatch } from 'redux';
import { Feature, createActionFactoryForFeature, ThunkDispatch } from '../../../../shared';
import { leaveGroupThunk } from '../../data/groups/leaveGroupActions';

const createActionFactory = createActionFactoryForFeature(Feature.UnifiedGroups);

export const leaveGroupConfirmClickedAction = createActionFactory<{
    groupId: string;
    hubPersonaId: string;
}>('LeaveGroupConfirmClickedAction');

export const dismissLeaveGroupDialogAction = createActionFactory<{
    groupId: string;
    hubPersonaId: string;
}>('DismissLeaveGroupDialogAction');

export const leaveGroupConfirmClicked = (dispatch: ThunkDispatch) => (
    groupId: string,
    groupSmtp: string,
    groupName: string,
    isExpiring: boolean,
    isOwner: boolean,
    membershipRequestsCount: number,
    userEmailAddress: string,
    hubPersonaId: string
) => {
    dispatch(leaveGroupConfirmClickedAction({ groupId, hubPersonaId }));
    dispatch(
        leaveGroupThunk(
            groupId,
            groupSmtp,
            groupName,
            isExpiring,
            isOwner,
            membershipRequestsCount,
            userEmailAddress,
            hubPersonaId
        )
    );
};

export const dismissLeaveGroupDialog = (dispatch: Dispatch) => (
    groupId: string,
    hubPersonaId: string
) => {
    dispatch(dismissLeaveGroupDialogAction({ groupId, hubPersonaId }));
};
export type { UnifiedGroup } from '../../../../shared';
export type { Action } from '../../../../shared';
